import * as React from 'react';
import { Button as FlowBiteButton, ButtonProps as FlowBiteButtonProps } from 'flowbite-react';
import { ButtonColorsEnum, ButtonSizesEnum, buttonIconTheme } from '../../styles/themes/button';

export type ButtonIconProps = Omit<FlowBiteButtonProps, 'label' | 'size' | 'color'> & {
    size: ButtonSizesEnum;
    color: ButtonColorsEnum;
    ariaLabel?: string;
    testId?: string;
};

export const ButtonIcon: React.FC<ButtonIconProps> = ({ children, testId, ...otherProps }) => {
    return (
        <FlowBiteButton pill theme={buttonIconTheme} data-testid={testId} {...otherProps}>
            {children}
        </FlowBiteButton>
    );
};
